import { HttpClient } from '@wix/sdk-types';
import {
  ProvisionBookingsPlatformOptions,
  provisionBookingsPlatform as universalProvisionBookingsPlatform,
} from './bookings-provisioner-v1-apps-cloned-bookings-provisioner.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/bookings' };

export function provisionBookingsPlatform(
  httpClient: HttpClient
): ProvisionBookingsPlatformSignature {
  return (appId: string, options?: ProvisionBookingsPlatformOptions) =>
    universalProvisionBookingsPlatform(
      appId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ProvisionBookingsPlatformSignature {
  /**
   * Sets up the [Wix Bookings platform](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings-platform/introduction) for an app.
   *
   * Use this method to initialize your app's booking infrastructure.
   * This creates a time slots configuration that controls how available time slots
   * are displayed to customers.
   *
   * The app must be installed on the site before calling this method.
   *
   * This method is idempotent. Calling it multiple times for the same app
   * has no effect if the configuration already exists.
   * @param - ID of your app for which to provision the Bookings Platform. Learn more about [app identity in the Bookings Platform](https://dev.wix.com/docs/api-reference/business-solutions/bookings/bookings-platform/app-identity-in-the-bookings-platform).
   */
  (appId: string, options?: ProvisionBookingsPlatformOptions): Promise<void>;
}

export {
  AccountInfo,
  ActionEvent,
  App,
  AppsClonedFromTemplate,
  Asset,
  BasedOn,
  CreateBusinessScheduleRequest,
  CreateBusinessScheduleResponse,
  DeleteContext,
  DeleteStatus,
  DisplayTimeZone,
  DomainEvent,
  DomainEventBodyOneOf,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  ExtendedFields,
  IdentificationData,
  IdentificationDataIdOneOf,
  MessageEnvelope,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Namespace,
  NamespaceChanged,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  ProvisionBookingsPlatformOptions,
  ProvisionBookingsPlatformRequest,
  ProvisionBookingsPlatformResponse,
  RestoreInfo,
  ServiceProvisioned,
  ServiceRemoved,
  SiteCreated,
  SiteCreatedContext,
  SiteDeleted,
  SiteHardDeleted,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  SitePublished,
  SitePurgedExternally,
  SiteRenamed,
  SiteTransferred,
  SiteUndeleted,
  SiteUnpublished,
  SiteUrlChanged,
  SplitInterval,
  StaffSelection,
  State,
  Strategy,
  StudioAssigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  StudioUnassigned,
  TimeSlotsConfiguration,
  UserDomainMediaDisabled,
  UserDomainMediaEnabled,
  WebhookIdentityType,
  WixelAssigned,
  WixelUnassigned,
} from './bookings-provisioner-v1-apps-cloned-bookings-provisioner.universal.js';
